import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import {
  GridContainer,
  GridRow,
  GridColumn,
  Button,
} from "arv-reactcomponents";
import { Checkout } from "npmlinks-constants";
import CheckoutValidator from "../CheckoutValidator";
import Analytics from "../../analytics";
import Event from "../../analytics/eventFactory";

@withRouter
class CheckoutSubheader extends Component {
  static gotoShipping() {
    Analytics.trackEvent({
      action: Event.action.PAYMENT_TO_DELIVERY_CLICK,
      category: Event.category.CHECKOUT,
    });
  }
  constructor() {
    super();
    this.isActive = this.isActive.bind(this);
    this.goToShipping = this.goToShipping.bind(this);
  }
  isActive(key) {
    const { currentView } = this.props;
    return Checkout.CHECKOUTPAGE.CHECKOUT_SUBHEADER[key].ACTIVE_ROUTES.includes(
      currentView,
    )
      ? "is-active"
      : "";
  }
  goToShipping() {
    this.props.history.push(Checkout.CHECKOUT_ROUTES.SUPPORTED.shipping);
  }

  render() {
    return (
      <div className="nw-checkoutsubheader">
        <GridContainer className="nw-checkoutsubheader-container">
          <GridRow>
            <GridColumn className="nwc-grid-col-sm-4 nw-desktop-only nw-checkoutsubheader-titlecontainer">
              <h3 className="nw-checkoutsubheader-title">
                {Checkout.CHECKOUTPAGE.CHECKOUT_SUBHEADER.TITLE}
              </h3>
            </GridColumn>
            <GridColumn className="nwc-grid-col-sm-4 nw-checkoutsubheader-buttoncontainer">
              <Button
                className={`nw-checkoutsubheader-button ${this.isActive(
                  "SHIPPING_BUTTON",
                )}`}
                onClick={this.goToShipping}
              >
                <span
                  className={`nw-checkoutsubheader-number ${this.isActive(
                    "SHIPPING_BUTTON",
                  )}`}
                >
                  {
                    Checkout.CHECKOUTPAGE.CHECKOUT_SUBHEADER.SHIPPING_BUTTON
                      .COUNT
                  }
                </span>
                <span>
                  {
                    Checkout.CHECKOUTPAGE.CHECKOUT_SUBHEADER.SHIPPING_BUTTON
                      .TEXT
                  }
                </span>
              </Button>
              <CheckoutValidator.component>
                <Button
                  className={`nw-checkoutsubheader-button ${this.isActive(
                    "PAYMENT_BUTTON",
                  )}`}
                >
                  <span
                    className={`nw-checkoutsubheader-number ${this.isActive(
                      "PAYMENT_BUTTON",
                    )}`}
                  >
                    {
                      Checkout.CHECKOUTPAGE.CHECKOUT_SUBHEADER.PAYMENT_BUTTON
                        .COUNT
                    }
                  </span>
                  <span>
                    {
                      Checkout.CHECKOUTPAGE.CHECKOUT_SUBHEADER.PAYMENT_BUTTON
                        .TEXT
                    }
                  </span>
                </Button>
              </CheckoutValidator.component>
            </GridColumn>
          </GridRow>
        </GridContainer>
      </div>
    );
  }
}

CheckoutSubheader.propTypes = {
  currentView: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: CheckoutSubheader,
  component: CheckoutSubheader,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/CheckoutSubheader/index.js